import { Outlet } from "react-router-dom";
import styled from "styled-components";
import WebHeader from "./Header";
import "./Style.less";
import WebFooter from "./Footer";

const LayoutContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
`;

const ContentContainer = styled.div`
  display: flex;
  flex: 1;
  overflow-y: auto;
  background-color: #000;
  padding-top: 50px;
  padding-bottom: 50px;
`;
const WebMainLayout = () => {
  return (
    <LayoutContainer>
      <WebHeader />
      <ContentContainer>
        <Outlet />
      </ContentContainer>
      <WebFooter />
    </LayoutContainer>
  );
};
export default WebMainLayout;
